import { List, TextField, EditButton, ShowButton, SimpleList, Datagrid, TopToolbar, CreateButton } from "react-admin";
import { EmptyList } from "server/components";
import { useMediaQuery } from "@mui/material";
import permissions from "app/permissions";
import { checkPermission } from "server/security/utils";
import { getPermissions } from "auth/security/securityUtils";
import AddDocumentsButton from "./AddDocuments/AddDocumentsButton";
import { settings } from "app";
import { MOBILE_BREAKPOINT } from "utils/constants";
import { DeclarationsExporter } from "./XlsxExporter";
import { ExportXlsButton } from "features/ExportXlsxButton";
import { MobileListRow } from "features/MobileListRow";

const ListDeclarations = () => {
  const isMobile = useMediaQuery(MOBILE_BREAKPOINT);
  const userPermissions = getPermissions();

  const ListActions = hasCreate => {
    return (
      <TopToolbar>
        {hasCreate && <CreateButton />}
        <ExportXlsButton exporter={DeclarationsExporter} />
      </TopToolbar>
    );
  };

  return (
    <List
      title="Декларации"
      sx={settings.style.expandStyle}
      actions={<ListActions hasCreate={checkPermission(userPermissions, permissions.canCreateDeclarations)} />}
    >
      {isMobile ? (
        <SimpleList
          empty={<EmptyList />}
          linkType={false}
          sx={settings.style.mobileList}
          primaryText={record => <MobileListRow fields={[{ label: "Име на български език", value: record.nameBg }]} />}
          secondaryText={record => (
            <div>
              <MobileListRow fields={[{ label: "Име на английски език", value: record.nameEn }]} />
              <div style={{ display: "flex", flexWrap: "wrap", gap: 4 }}>
                {checkPermission(getPermissions(), permissions.canAddDocumentsDeclarations) && <AddDocumentsButton />}
              </div>
            </div>
          )}
          tertiaryText={() => (
            <>
              {checkPermission(getPermissions(), permissions.canUpdateDeclarations) && <EditButton label="" />}
              <ShowButton label="" />
            </>
          )}
        />
      ) : (
        <Datagrid
          bulkActionButtons={false}
          rowClick={false}
          sx={settings.style.firstExpandIconDatagrid}
        >
          <TextField
            source="nameBg"
            label="Име на български език"
            sortable={false}
          />
          <TextField
            source="nameEn"
            label="Име на английски език"
            sortable={false}
          />
          {checkPermission(getPermissions(), permissions.canAddDocumentsDeclarations) && <AddDocumentsButton />}
          {checkPermission(getPermissions(), permissions.canUpdateDeclarations) && <EditButton />}
          <ShowButton />
        </Datagrid>
      )}
    </List>
  );
};
export default ListDeclarations;
